export const environment = {
  production: false,
  name: 'staging',
  apiBaseUrl: 'https://vodafone.cert-stg.lantronix.com',
  tenantName: 'vodafone',
};
